import { Autocomplete, Box, Button, Chip, ChipDelete, FormControl, FormLabel, IconButton, Input, Modal, ModalClose, ModalDialog, ModalOverflow, Option, Select, Sheet, Stack, Typography } from "@mui/joy";
import { useContext, useEffect, useState } from "react";

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import StarsRoundedIcon from '@mui/icons-material/StarsRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';

import { motion, AnimatePresence } from "framer-motion";
import { LayoutContext } from "../../context";
import { APIGetHobbies, APIGetProfile, APIGetProfileStatus, APIUpdatePartnerPreferences } from "../../api";
import { useNavigate } from "react-router";

// Константы с вариантами выбора
const INCOME_OPTIONS = [
  { value: 0, label: '0 - 100 000' },
  { value: 1, label: '100 000 - 300 000' },
  { value: 2, label: '300 000 - 500 000' },
  { value: 3, label: '500 000 - 1 000 000' },
  { value: 4, label: '1 000 000 - 5 000 000' },
  { value: 5, label: 'Выше 5 000 000' },
];

const GENDER_INTEREST_OPTIONS = [
  { value: 0, label: 'Мужчину' },
  { value: 1, label: 'Женщину' },
  { value: 2, label: 'Пару МЖ' },
  { value: 3, label: 'Пару ЖЖ' },
  { value: 4, label: 'Пару ММ' }
];

const PURPOSE_OPTIONS_BY_GENDER = {
  // Для поиска мужчины/женщины
  individual: [
    { value: 0, label: 'Брак' },
    { value: 1, label: 'Общение' },
    { value: 2, label: 'Веселое время сопровождение' },
  ],
  // Для поиска пары
  couple: [
    { value: 2, label: 'Веселое время сопровождение' }
  ]
};

export default function SecondQuestionnaireForm() {
    const { token, currentUser, profileUser, deviceType, setProfileUser, profileStatus, setProfileStatus, modalSecondQuestionnaire, setModalSecondQuestionnaire, updateStatusListProfiles, setUpdateStatusListProfiles } = useContext(LayoutContext);
    const navigate = useNavigate();

    const [ loading, setLoading ] = useState(false);
    const [ hobbies, setHobbies ] = useState([]);
    const [ selectedPartnerHobbies, setSelectedPartnerHobbies ] = useState([]);
    
    // Состояние формы для второй части анкеты
    const [ formData, setFormData ] = useState({
        min_age: 18,
        max_age: 35,
        min_partner_weight: null,
        max_partner_weight: null,
        min_partner_height: null,
        max_partner_height: null,
        partner_income: null,
        search_by_geolocation: true,
        search_in_other_city: false,
        partner_city: '',
        gender_interest: null,
        purpose_of_search: null
    });

    // Загрузка хобби при открытии модального окна
    useEffect(() => {
        const loadHobbies = async () => {
            if (modalSecondQuestionnaire?.open && token) {
                try {
                    const hobbiesData = await APIGetHobbies(token);
                    setHobbies(hobbiesData.hobbies || []);
                } catch (error) {
                    console.error('Ошибка загрузки хобби:', error);
                }
            }
        };
        
        loadHobbies();
    }, [modalSecondQuestionnaire?.open, token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const getFilteredPurposeOptions = () => {
        const genderInterest = formData.gender_interest;
        
        // Если выбрано "Мужчину" или "Женщину"
        if (genderInterest === 0 || genderInterest === 1) {
            return PURPOSE_OPTIONS_BY_GENDER.individual;
        }
        // Если выбрано "Пару" (МЖ, ЖЖ, ММ)
        else if (genderInterest >= 2 && genderInterest <= 4) {
            return PURPOSE_OPTIONS_BY_GENDER.couple;
        }
        
        return [];
    };

    const getFilteredGenderOptions = () => {
        const userGender = profileUser?.gender;
        
        console.log("userGender", userGender);
        if (userGender != null || userGender != undefined) {
            if (userGender === 0) { // Мужчина
                return GENDER_INTEREST_OPTIONS.filter(opt => 
                    opt.value === 1 // Исключаем мужчин
                );
            } else if (userGender === 1) { // Женщина
                return GENDER_INTEREST_OPTIONS.filter(opt => 
                    opt.value === 0 // Исключаем женщин
                );
            } else if (userGender >= 2) { // Пара
                return GENDER_INTEREST_OPTIONS; // Все варианты для пар
            }
        }
        
        return GENDER_INTEREST_OPTIONS;
    };

    const handleSelectChange = (name, value) => {
        // Преобразуем числовые значения
        const numericFields = ['partner_income', 'gender_interest', 'purpose_of_search'];
        const processedValue = numericFields.includes(name) && value !== null 
            ? parseInt(value) 
            : value;
            
        setFormData(prev => ({ ...prev, [name]: processedValue }));
    };

    const handleCheckboxChange = (name) => {
        setFormData(prev => ({ ...prev, [name]: !prev[name] }));
    };

    // Эффект для автоматического открытия модального окна при необходимости
    // useEffect(() => {
    //     if (profileStatus?.has_profile && profileStatus?.basic_complete && !profileStatus?.partner_preferences_complete) {
    //         setModalSecondQuestionnaire({ open: true });
    //     }
    // }, [profileStatus]);

    // Эффект для загрузки данных профиля при открытии
    useEffect(() => {
        const loadProfileData = async () => {
            if (modalSecondQuestionnaire?.open && token && profileUser) {
                try {
                    // Заполняем форму данными из профиля с преобразованием типов
                    setFormData({
                        min_age: profileUser.min_age || 18,
                        max_age: profileUser.max_age || 35,
                        min_partner_weight: profileUser.min_partner_weight || null,
                        max_partner_weight: profileUser.max_partner_weight || null,
                        min_partner_height: profileUser.min_partner_height || null,
                        max_partner_height: profileUser.max_partner_height || null,
                        partner_income: profileUser.partner_income !== null && profileUser.partner_income !== undefined 
                            ? parseInt(profileUser.partner_income) 
                            : null,
                        search_by_geolocation: (profileUser.search_by_geolocation !== undefined 
                            ? profileUser.search_by_geolocation 
                            : true),
                        search_in_other_city: !(profileUser.search_by_geolocation !== undefined 
                            ? profileUser.search_by_geolocation 
                            : true), // Противоположное значение
                        partner_city: profileUser.partner_city || '',
                        gender_interest: profileUser.gender_interest !== null && profileUser.gender_interest !== undefined
                            ? parseInt(profileUser.gender_interest)
                            : null,
                        purpose_of_search: profileUser.purpose_of_search !== null && profileUser.purpose_of_search !== undefined
                            ? parseInt(profileUser.purpose_of_search)
                            : null
                    });

                    // Загружаем хобби партнера из профиля
                    if (profileUser?.partner_hobbies) {
                        const partnerHobbies = profileUser.partner_hobbies
                            .filter(hobby => !hobby.is_custom)
                            .map(hobby => hobby.id)
                            .filter(Boolean);
                        setSelectedPartnerHobbies(partnerHobbies);
                    }
                } catch (error) {
                    console.error('Ошибка загрузки данных профиля:', error);
                }
            }
        };
        
        loadProfileData();
    }, [modalSecondQuestionnaire, token, profileUser]);

    const handleSearchInMyCity = () => {
        setFormData(prev => ({ 
            ...prev, 
            search_by_geolocation: false,
            search_in_other_city: true,
            partner_city: '' // Очищаем поле города при переключении
        }));
    };

    // Обработчик для хобби партнера
    const handlePartnerHobbiesChange = (event, newValue) => {
        setSelectedPartnerHobbies(newValue.map(item => item.id));
    };

    const handleSearchInOtherCity = () => {
        setFormData(prev => ({ 
            ...prev, 
            search_by_geolocation: true,
            search_in_other_city: false
        }));
    };

    // Сохранение предпочтений партнера
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData?.min_age < 18 || formData?.max_age > 100) {
            alert("Укажите возраст от 18 до 100");
            return
        }
        if (formData?.min_age > formData?.max_age) {
            alert("Минимальный возраст не должен быть больше максимального");
            return
        }
        if (formData.min_partner_weight && formData.max_partner_weight && formData.min_partner_weight > formData.max_partner_weight) {
            alert("Минимальный вес не должен быть больше максимального");
            return;
        }
        if (formData.min_partner_height && formData.max_partner_height && formData.min_partner_height > formData.max_partner_height) {
            alert("Минимальный рост не должен быть больше максимального");
            return;
        }

        setLoading(true);

        try {
            // Создаем объект данных для отправки
            const dataToSend = {
                ...formData,
                partner_hobby_ids: selectedPartnerHobbies // Добавляем хобби партнера
            };

            const response = await APIUpdatePartnerPreferences(token, profileUser.id, dataToSend);

            if (response?.success) {
                setModalSecondQuestionnaire({ open: false });
                
                // Обновляем статус профиля в контексте
                if (currentUser?.id) {
                    const statusData = await APIGetProfileStatus(token, currentUser.id);
                    const profileData = await APIGetProfile(token);
                    setProfileUser(profileData);
                    setProfileStatus(statusData);
                    setModalSecondQuestionnaire({ open: false });
                    setUpdateStatusListProfiles(!updateStatusListProfiles);
                }
            }
        } catch (error) {
            console.error('Ошибка при сохранении предпочтений:', error);
            alert('Ошибка при сохранении предпочтений: ' + 
                (error.response?.data?.error || error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {modalSecondQuestionnaire?.open && (
                <Modal
                    sx={{ zIndex: 10002 }}
                    open={modalSecondQuestionnaire?.open}
                    slotProps={{
                        backdrop: {
                            component: motion.div,
                            initial: { opacity: 0, backdropFilter: 'blur(0px)' },
                            animate: { opacity: 1, backdropFilter: 'blur(8px)' },
                            exit: { opacity: 0, backdropFilter: 'blur(0px)' },
                            transition: { duration: 0.3, ease: "easeInOut" },
                        }
                    }}
                >
                    <ModalOverflow sx={{ height: 'auto' }}>
                        <ModalDialog
                            layout="fullscreen"
                            size="lg"
                            component={motion.div}
                            initial={{ opacity: 0, y: -10, scale: 0.98 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: 10, scale: 0.98 }}
                            transition={{ duration: 0.2, ease: "easeInOut" }}
                            sx={(theme) => ({
                                [theme.breakpoints.up("xl")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("xl")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("lg")]: { width: '550px', mx: 0 },
                                [theme.breakpoints.down("md")]: { width: '450px', mx: 0 },
                                [theme.breakpoints.down("sm")]: { width: '95%', p: 3 },
                                width: '100%'
                            })}
                        >
                            <Box sx={{ mt: deviceType == 'Phone' ? 10 : 0 }}></Box>

                            <ModalClose sx={{ mt: deviceType == 'Phone' ? 10 : 0 }} onClick={() => {
                                if (profileStatus?.partner_preferences_complete)
                                    setModalSecondQuestionnaire({ open: false });
                                else {
                                    // navigate(-1);
                                    setModalSecondQuestionnaire({ open: false });
                                }
                            }}
                            />

                            <Stack direction={"column"} alignItems={'center'} spacing={4} sx={{ mt: 8, mb: 1 }}>
                                <Stack direction={"column"} sx={{ zIndex: 2, alignItems: "center" }} position={'relative'}>
                                    <Box
                                        sx={{ 
                                            width: 90,
                                            height: 90,
                                            borderRadius: '50%',
                                            backgroundColor: 'primary.100',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <SearchRoundedIcon sx={{ color: 'primary.600', fontSize: 40 }} />
                                    </Box>
                                </Stack>
                                <Typography sx={{ textAlign: 'center', mb: 0, zIndex: 1, lineHeight: 1.2 }} level="h2">
                                    Настройте параметры поиска
                                </Typography>
                                <Sheet
                                    color="primary"
                                    variant="soft"
                                    sx={{
                                        py: 1.5,
                                        px: 2,
                                        borderRadius: 'xl'
                                    }}
                                >
                                    <Typography startDecorator={<StarsRoundedIcon sx={{ fontSize: "xl" }} color="primary" />} sx={{ color: 'neutral.500', gap: 1 }} level="body-sm">
                                        Укажите предпочтения для идеального подбора партнеров
                                    </Typography>
                                </Sheet>
                            </Stack>
                            
                            <form onSubmit={handleSubmit}>
                                <Stack spacing={3}
                                    sx={(theme) => ({
                                        [theme.breakpoints.down("sm")]: { width: '100%' },
                                        width: 500,
                                        mx: 'auto'
                                    })}
                                >
                                    <Sheet color="neutral" variant="outlined" sx={{ p: 2, borderRadius: 'lg' }}>
                                        {/* Возрастной диапазон */}
                                        <FormControl>
                                            <FormLabel sx={{ fontWeight: 'lg' }}>Возраст партнера*</FormLabel>
                                            <Stack direction="row" spacing={2} alignItems="center">
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>От</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => formData.min_age > 18 && setFormData({...formData, min_age: formData.min_age - 1})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.min_age} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const age = parseInt(e.target.value);
                                                                setFormData({...formData, min_age: age});
                                                            }} 
                                                            required 
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => formData.min_age < formData.max_age && setFormData({...formData, min_age: formData.min_age + 1})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                                
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>До</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => formData.max_age > formData.min_age && setFormData({...formData, max_age: formData.max_age - 1})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.max_age} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const age = parseInt(e.target.value);
                                                                setFormData({...formData, max_age: age});
                                                            }} 
                                                            required 
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => formData.max_age < 100 && setFormData({...formData, max_age: formData.max_age + 1})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                            </Stack>
                                        </FormControl>
                                    </Sheet>
                                    
                                    <Sheet color="neutral" variant="outlined" sx={{ p: 2, borderRadius: 'lg' }}>
                                        {/* Промежуток веса партнера */}
                                        <FormControl>
                                            <FormLabel sx={{ fontWeight: 'lg' }}>Вес партнера (кг)</FormLabel>
                                            <Stack direction="row" spacing={2} alignItems="center">
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>От</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, min_partner_weight: Math.max(30, (formData.min_partner_weight || 30) - 5)})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.min_partner_weight || ''} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const weight = e.target.value ? parseInt(e.target.value) : null;
                                                                setFormData({...formData, min_partner_weight: weight});
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    min: 30,
                                                                    max: 300
                                                                }
                                                            }}
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, min_partner_weight: Math.min(300, (formData.min_partner_weight || 30) + 5)})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                                
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>До</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, max_partner_weight: Math.max((formData.min_partner_weight || 30), (formData.max_partner_weight || 80) - 5)})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.max_partner_weight || ''} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const weight = e.target.value ? parseInt(e.target.value) : null;
                                                                setFormData({...formData, max_partner_weight: weight});
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    min: 30,
                                                                    max: 300
                                                                }
                                                            }}
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, max_partner_weight: Math.min(300, (formData.max_partner_weight || 80) + 5)})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                            </Stack>
                                            <Typography level="body-xs" sx={{ color: 'neutral.500', mt: 0.5 }}>
                                                Диапазон: 30-300 кг
                                            </Typography>
                                        </FormControl>
                                    </Sheet>

                                    <Sheet color="neutral" variant="outlined" sx={{ p: 2, borderRadius: 'lg' }}>
                                        {/* Промежуток роста партнера */}
                                        <FormControl>
                                            <FormLabel sx={{ fontWeight: 'lg' }}>Рост партнера (см)</FormLabel>
                                            <Stack direction="row" spacing={2} alignItems="center">
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>От</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, min_partner_height: Math.max(100, (formData.min_partner_height || 150) - 5)})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.min_partner_height || ''} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const height = e.target.value ? parseInt(e.target.value) : null;
                                                                setFormData({...formData, min_partner_height: height});
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    min: 100,
                                                                    max: 250
                                                                }
                                                            }}
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, min_partner_height: Math.min(250, (formData.min_partner_height || 150) + 5)})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                                
                                                <Box sx={{ flex: 1 }}>
                                                    <FormLabel>До</FormLabel>
                                                    <Stack direction="row" spacing={1} alignItems="center">
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, max_partner_height: Math.max((formData.min_partner_height || 150), (formData.max_partner_height || 190) - 5)})}
                                                        >
                                                            <RemoveRoundedIcon/>
                                                        </IconButton>
                                                        <Input 
                                                            sx={{ borderRadius: 'md', maxWidth: 70, textAlign: "center" }} 
                                                            value={formData.max_partner_height || ''} 
                                                            type="number"
                                                            onChange={(e) => {
                                                                const height = e.target.value ? parseInt(e.target.value) : null;
                                                                setFormData({...formData, max_partner_height: height});
                                                            }}
                                                            slotProps={{
                                                                input: {
                                                                    min: 100,
                                                                    max: 250
                                                                }
                                                            }}
                                                        />
                                                        <IconButton 
                                                            variant={'soft'} 
                                                            color={'primary'} 
                                                            size="sm"
                                                            onClick={() => setFormData({...formData, max_partner_height: Math.min(250, (formData.max_partner_height || 190) + 5)})}
                                                        >
                                                            <AddRoundedIcon/>
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                            </Stack>
                                            <Typography level="body-xs" sx={{ color: 'neutral.500', mt: 0.5 }}>
                                                Диапазон: 100-250 см
                                            </Typography>
                                        </FormControl>
                                    </Sheet>

                                    {/* Доход партнера */}
                                    <FormControl>
                                        <FormLabel sx={{ fontWeight: 'lg' }}>Доход партнера*</FormLabel>
                                        <Select
                                            slotProps={{ listbox: { sx: { zIndex: 10010 } } }}
                                            name="partner_income"
                                            value={formData.partner_income}
                                            onChange={(e, value) => handleSelectChange('partner_income', value)}
                                            placeholder="Выберите желаемый доход партнера"
                                            required
                                        >
                                            {INCOME_OPTIONS.map((option) => (
                                                <Option key={option.value} value={option.value}>
                                                    {option.label}
                                                </Option>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {/* Обновленная секция геолокации */}
                                    <FormControl>
                                        <FormLabel sx={{ fontWeight: 'lg' }}>Геолокация поиска*</FormLabel>
                                        <Stack spacing={1}>
                                            <Sheet 
                                                variant="outlined" 
                                                sx={{ 
                                                    py: 1,
                                                    px: 1.2, 
                                                    borderRadius: 'md', 
                                                    display: 'flex', 
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    cursor: 'pointer',
                                                    borderColor: formData.search_in_other_city ? 'primary.500' : 'neutral.300',
                                                    backgroundColor: formData.search_in_other_city ? 'primary.50' : 'transparent'
                                                }}
                                                onClick={handleSearchInMyCity}
                                            >
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <ApartmentRoundedIcon sx={{ fontSize: "xl" }} />
                                                    <Typography level="body-sm" sx={{ lineHeight: 1.2 }}>Искать в моем городе</Typography>
                                                </Stack>
                                                <Box
                                                    sx={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: '50%',
                                                        border: '2px solid',
                                                        borderColor: formData.search_in_other_city ? 'primary.500' : 'neutral.300',
                                                        backgroundColor: formData.search_in_other_city ? 'primary.500' : 'transparent',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {formData.search_in_other_city && (
                                                        <Box
                                                            sx={{
                                                                width: 8,
                                                                height: 8,
                                                                borderRadius: '50%',
                                                                backgroundColor: 'white'
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </Sheet>
                                            
                                            <Sheet 
                                                variant="outlined" 
                                                sx={{ 
                                                    py: 1,
                                                    px: 1.2, 
                                                    borderRadius: 'md', 
                                                    display: 'flex', 
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    cursor: 'pointer',
                                                    borderColor: formData.search_by_geolocation ? 'primary.500' : 'neutral.300',
                                                    backgroundColor: formData.search_by_geolocation ? 'primary.50' : 'transparent'
                                                }}
                                                onClick={handleSearchInOtherCity}
                                            >
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <LocationOnRoundedIcon sx={{ fontSize: "xl" }} />
                                                    <Typography level="body-sm" sx={{ lineHeight: 1.2 }}>Искать в другом городе</Typography>
                                                </Stack>
                                                <Box
                                                    sx={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: '50%',
                                                        border: '2px solid',
                                                        borderColor: formData.search_by_geolocation ? 'primary.500' : 'neutral.300',
                                                        backgroundColor: formData.search_by_geolocation ? 'primary.500' : 'transparent',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {formData.search_by_geolocation && (
                                                        <Box
                                                            sx={{
                                                                width: 8,
                                                                height: 8,
                                                                borderRadius: '50%',
                                                                backgroundColor: 'white'
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </Sheet>
                                        </Stack>
                                    </FormControl>

                                    {/* Поле для ввода города при выборе поиска в другом городе */}
                                    {formData.search_by_geolocation && (
                                        <FormControl>
                                            <FormLabel sx={{ fontWeight: 'lg' }}>Город для поиска*</FormLabel>
                                            <Input
                                                name="partner_city"
                                                value={formData.partner_city} 
                                                onChange={handleChange}
                                                size="md" 
                                                placeholder="Введите город для поиска"
                                                startDecorator={<LocationOnRoundedIcon sx={{ fontSize: 'lg' }} />}
                                                required
                                            />
                                        </FormControl>
                                    )}

                                    {/* Кого ищет */}
                                    <Select
                                        slotProps={{ listbox: { sx: { zIndex: 10010 } } }}
                                        name="gender_interest"
                                        value={formData.gender_interest}
                                        onChange={(e, value) => {
                                            handleSelectChange('gender_interest', value);
                                            // Автоматически устанавливаем цель для пар
                                            if (value >= 2 && value <= 4) {
                                            setFormData(prev => ({ 
                                                ...prev, 
                                                purpose_of_search: 2 // "Веселое время сопровождение" для пар
                                            }));
                                            } else {
                                            // Сбрасываем цель для индивидуального поиска
                                            setFormData(prev => ({ 
                                                ...prev, 
                                                purpose_of_search: null 
                                            }));
                                            }
                                        }}
                                        placeholder="Кого вы ищете?"
                                        required
                                    >
                                        {getFilteredGenderOptions().map((option) => (
                                            <Option key={option.value} value={option.value}>
                                            {option.label}
                                            </Option>
                                        ))}
                                    </Select>

                                    {/* Цель знакомства */}
                                    <FormControl>
                                        <FormLabel sx={{ fontWeight: 'lg' }}>Цель знакомства*</FormLabel>
                                        <Select
                                            slotProps={{ listbox: { sx: { zIndex: 10010 } } }}
                                            name="purpose_of_search"
                                            value={formData.purpose_of_search}
                                            onChange={(e, value) => handleSelectChange('purpose_of_search', value)}
                                            placeholder="Выберите цель"
                                            disabled={formData.gender_interest === null || formData.gender_interest === undefined}
                                            required
                                        >
                                            {getFilteredPurposeOptions().map((option) => (
                                            <Option key={option.value} value={option.value}>
                                                {option.label}
                                            </Option>
                                            ))}
                                        </Select>
                                        {(formData.gender_interest === null || formData.gender_interest === undefined) && (
                                            <Typography level="body-xs" sx={{ color: 'neutral.500', mt: 1 }}>
                                                Сначала выберите "Кого ищу"
                                            </Typography>
                                        )}
                                    </FormControl>

                                    {/* Секция хобби партнера - показываем только если ищется пара */}
                                    {/* {(formData.gender_interest >= 2 && formData.gender_interest <= 4) && ( */}
                                    <FormControl>
                                        <FormLabel sx={{ fontWeight: 'lg' }}>Хобби партнера</FormLabel>
                                        <Autocomplete
                                            multiple
                                            options={hobbies}
                                            getOptionLabel={(option) => option.name}
                                            value={hobbies.filter(hobby => selectedPartnerHobbies.includes(hobby.id))}
                                            onChange={handlePartnerHobbiesChange}
                                            slotProps={{ listbox: { sx: { zIndex: 10010 } } }}
                                            renderTags={(value, getTagProps) =>
                                                value.map((option, index) => (
                                                    <Chip
                                                        variant="soft"
                                                        color="primary"
                                                        {...getTagProps({ index })}
                                                    >
                                                        {option?.name}
                                                    </Chip>
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <Input
                                                    {...params}
                                                    placeholder="Выберите хобби партнера"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    {/* )} */}

                                    <Stack sx={{ mt: 2 }}>
                                        <Button 
                                            size="lg"
                                            variant="solid"
                                            loading={loading}
                                            type="submit"
                                            sx={{ mt: 1 }}
                                        >
                                            Сохранить настройки
                                        </Button>
                                        
                                        <Typography level="body-xs" sx={{ color: "neutral.400", textAlign: "center", mt: 1 }}>
                                            Эти настройки помогут нам точнее подбирать подходящих партнеров
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </form>
                        </ModalDialog>
                    </ModalOverflow>
                </Modal>
            )}
        </AnimatePresence>
    );
}